import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Form,
  Grid,
  Header,
  Message,
  Segment,
} from "semantic-ui-react";
import { axiosInstance } from "../../fetcher";
//For checking purpose printing it
console.log("window.location.orgin -",window.location.origin);
console.log("window.location.href -",window.location.href);
const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [showCode, setShowCode] = useState(false);
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);
  const [isSubmitting,setIsSubmitting]=useState(false);

  const handleLogin = async () => {
    setIsSubmitting(true);
    try {
      const response = await axiosInstance.post("/auth/login", {
        username: username,
        password: password,
      });
      if (response.status === 200) {
        localStorage.setItem("accessToken", response.data.accessToken);
        localStorage.setItem("refreshToken", response.data.refreshToken);
        localStorage.setItem("isAdmin", response.data.role === "admin");
        setShowCode(true);
        // navigate("/translator");
      }
    } catch (error) {
      setError("Invalid username or password");
      return;
    }
    finally{setIsSubmitting(false)}
  };

  const handleVerifyCode = async () => {
    try {
      const response = await axiosInstance.post(
        `/auth/verify-totp?otp_code=${code}`
      );
      if (response.status === 200) {
        // localStorage.setItem("accessToken", response.data.accessToken);
        // localStorage.setItem("refreshToken", response.data.refreshToken);
        navigate("/translator");
      }
    } catch (error) {
      setError("Invalid code");
    }
  };

  return (
    <Grid textAlign="center" style={{ height: "100vh" }} verticalAlign="middle">
      <Grid.Column style={{ maxWidth: 450 }}>
        <Header as="h2" color="teal" textAlign="center">
          Log-in to your account
        </Header>
        <Form size="large">
          <Segment stacked>
            <Form.Input
              fluid
              type="text"
              icon="user"
              iconPosition="left"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <Form.Input
              fluid
              icon="lock"
              iconPosition="left"
              placeholder="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            {showCode && (
              <Form.Input
                fluid
                icon="key"
                iconPosition="left"
                placeholder="Enter Code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
              />
            )}

            <Button
              color="teal"
              fluid
              size="large"
              disabled={isSubmitting}
              onClick={showCode ? handleVerifyCode : handleLogin}
            >
              {showCode ? "Submit Code" : "Generate OTP"}
            </Button>
          </Segment>
        </Form>

        {error && <Message negative>{error}</Message>}
      </Grid.Column>
    </Grid>
  );
};

export default Login;
